module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "2em",
      "margin-bottom": "1em"
    }
  }, [_vm._v("\n            主帳號資訊\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon min-w-220 text-align-left"
  }, [_vm._v("編號")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.user_no) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon min-w-220 text-align-left"
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.nickname) + "\n                ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group "
  }, [_c('span', {
    staticClass: "input-group-addon min-w-220 text-align-left"
  }, [_vm._v("手機")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                  " + _vm._s(_vm.memberInfo.phone) + "\n                  "), (_vm.memberInfo.is_phone_valid == 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未通過")]) : _vm._e(), _vm._v(" "), (_vm.memberInfo.is_phone_valid == 1) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("已通過")]) : _vm._e()])]), _vm._v(" "), _c('br')])]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('div', {
    staticClass: "box-body form-center min-h-640"
  }, [_c('br'), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("\n              綁定副帳號資訊\n            ")]), _vm._v(" "), (_vm.integrateMemberList.length) ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.integrateMemberList), function(mem, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n                        " + _vm._s(index + 1) + "\n                      ")]), _vm._v(" "), _c('td', [(mem.account_type == 1) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/phone.svg"
      }
    })]) : _vm._e(), _vm._v(" "), (mem.account_type == 2) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/fb.png"
      }
    })]) : _vm._e(), _vm._v(" "), (mem.account_type == 3) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/google.png"
      }
    })]) : _vm._e(), _vm._v(" "), (mem.account_type == 4) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      staticStyle: {
        "margin-right": "8px"
      },
      attrs: {
        "src": "/static/img/icon/line.png"
      }
    })]) : _vm._e(), (_vm.memberInfo.create_account_owner_type == 2 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(" + _vm._s(_vm.memberInfo.create_account_owner_brand_name) + ")")]) : (_vm.memberInfo.create_account_owner_type == 1 && _vm.memberInfo.create_account_type == 4) ? _c('span', [_vm._v("(你訂)")]) : _vm._e(), _vm._v(" "), (mem.account_type == 5) ? _c('span', [_c('img', {
      staticClass: "img-login-type img-round",
      attrs: {
        "src": "/static/img/icon/jkos.svg"
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(mem.user_name) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(mem.provider_owner_name) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(mem.integrate_time) + "\n                      ")])])
  }), 0)])])])]) : _c('div', [_vm._v("\n              無整合帳號\n            ")])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("類型")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("暱稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("品牌")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("整合時間")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47824708"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/UpgradeMemberInfo.vue
// module id = 2400
// module chunks = 1